import {
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_REQUEST,
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_REQUEST,
  INSTALLER_SEARCH_REQUEST,
  ASSIGN_TOKENS_TO_INSTALLER_REQUEST,
  ASSIGN_TOKENS_TO_DISTRIBUTOR_REQUEST,
  GET_STORE_URL_REQUEST
} from './constants';

export function getGeneratorTokenDistributorList(payload, isSearch = false) {
  return { type: GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_REQUEST, payload, loading: !isSearch };
}

export function getGeneratorTokenDistributorListBulk(payload, isSearch = false) {
  return { type: GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_REQUEST, payload, loading_bulk: !isSearch };
}

export function getInstallerSearch(payload) {
  return { type: INSTALLER_SEARCH_REQUEST, payload };
}

export function assignTokensToInstaller(payload) {
  return { type: ASSIGN_TOKENS_TO_INSTALLER_REQUEST, payload };
}

export function assignTokensToDistributor(payload) {
  return { type: ASSIGN_TOKENS_TO_DISTRIBUTOR_REQUEST, payload };
}

export function getStoreUrl(payload) {
  return { type: GET_STORE_URL_REQUEST, payload };
}